import EventTracking from 'lib/EventTracking';
import userAgent from 'lib/currentUserAgent';

class CanvasImage {
  constructor(ctx, src) {
    this.ctx = ctx;

    this.img = document.createElement('img');
    this.img.onload = () => {
      this.loaded = true;
    };
    this.img.src = src;
  }

  static createTiles(tiles, ctx) {
    const objs = [];

    tiles.forEach(tile => {
      const obj = new this(ctx);
      obj.x += tile.left * obj.w - tile.left;
      obj.y += tile.top * obj.h - tile.top;
      objs.push(obj);
    });

    return objs;
  }

  update() {
    this.x += this.vx;
    this.y += this.vy;
  }

  draw() {
    this.ctx.save();
    this.ctx.translate(this.x, this.y);
    if (this.a) {
      // Rotate about the origin of the object
      this.ctx.translate(this.w / 2, this.h / 2);
      this.ctx.rotate((Math.PI / 180) * this.a);
      this.ctx.translate(-this.w / 2, -this.h / 2);
    }
    if (this.loaded) {
      this.ctx.drawImage(this.img, 0, 0, this.w, this.h);
    }
    this.ctx.restore();
  }
}

class SmallClouds extends CanvasImage {
  constructor(ctx) {
    super(ctx, require('assets/images/small-clouds.svg'));

    this.x = 0;
    this.y = 0;
    this.w = 916;
    this.h = ctx.canvas.height;
    this.vx = -0.25;
    this.vy = 0;
  }
}

class BigClouds extends CanvasImage {
  constructor(ctx) {
    super(ctx, require('assets/images/big-clouds.svg'));

    this.x = 0;
    this.y = 0;
    this.w = 916;
    this.h = ctx.canvas.height;
    this.vx = -0.5;
    this.vy = 0;
  }
}

class SmallTrees extends CanvasImage {
  constructor(ctx) {
    super(ctx, require('assets/images/small-trees.svg'));

    this.x = 0;
    this.y = 0;
    this.w = 916;
    this.h = ctx.canvas.height;
    this.vx = -1;
    this.vy = 0;
  }
}

class BigTrees extends CanvasImage {
  constructor(ctx) {
    super(ctx, require('assets/images/big-trees.svg'));

    this.x = 0;
    this.y = 0;
    this.w = 916;
    this.h = ctx.canvas.height;
    this.vx = -2;
    this.vy = 0;
  }
}

class Bus extends CanvasImage {
  constructor(ctx) {
    super(ctx, require('assets/images/bus.svg'));

    this.x = -106;
    this.y = 15;
    this.w = 106;
    this.h = 35;
    this.vx = 4;
    this.vy = 0;
  }

  update() {
    this.vx += Math.log(Math.abs((this.x + this.w / 2) / this.ctx.canvas.width) + 1) / 4;
    this.a = Math.sin(this.x / 20);

    super.update();
  }
}

class Wheels extends CanvasImage {
  constructor(ctx) {
    super(ctx, require('assets/images/wheels.svg'));

    this.x = -92;
    this.y = 44;
    this.w = 82;
    this.h = 12;
    this.vx = 4;
    this.vy = 0;
  }

  update() {
    this.vx += Math.log(Math.abs((this.x + this.w / 2) / this.ctx.canvas.width) + 1) / 4;

    super.update();
  }
}

export default class DriveBy {
  constructor(parent) {
    this.canvas = document.createElement('canvas');
    if (!this.canvas.getContext || userAgent.ie() || userAgent.firefox()) {
      return;
    }

    this.ctx = this.canvas.getContext('2d');
    this.parent = parent;

    this.canvas.style.position = 'absolute';
    this.canvas.style.left = '0';
    this.canvas.style.top = '0';
    this.canvas.width = this.parent.offsetWidth;
    this.canvas.height = this.parent.offsetHeight;
    this.canvas.style.background = '#e5edee';
    this.canvas.style.webkitAnimation = 'driveby 5s ease infinite';
    this.canvas.style.animation = 'driveby 5s ease infinite';
    this.canvas.style.zIndex = '102';

    EventTracking.view('DriveBy');
    this._start();
  }

  _start() {
    this.parent.appendChild(this.canvas);

    this.drawings = [];
    const tiles = [{ left: 0, top: 0 }, { left: 1, top: 0 }, { left: 2, top: 0 }, { left: 3, top: 0 }];

    this.drawings.push(...SmallClouds.createTiles(tiles, this.ctx));
    this.drawings.push(...BigClouds.createTiles(tiles, this.ctx));
    this.drawings.push(...SmallTrees.createTiles(tiles, this.ctx));
    this.drawings.push(...BigTrees.createTiles(tiles, this.ctx));
    this.drawings.push(this.bus = new Bus(this.ctx));
    this.drawings.push(new Wheels(this.ctx));

    this._loop();

    // Incase the bus doesn't make it to the other side...
    setTimeout(() => this._stop(), 10000);
  }

  _update() {
    this.canvas.width = this.parent.offsetWidth;

    this.drawings.forEach(drawing => drawing.update());
  }

  _draw() {
    this.drawings.forEach(drawing => drawing.draw());
  }

  _loop() {
    if (!this.canvas || (this.bus.x > this.canvas.width)) {
      return this._stop();
    }

    this._update();
    this._draw();

    window.requestAnimationFrame(() => this._loop(), 1000 / 60);
  }

  _stop() {
    if (this.canvas) {
      this.parent.removeChild(this.canvas);
    }

    this.canvas = null;
  }
}



// WEBPACK FOOTER //
// ./src/lib/DriveBy.js